export const toolbarTokens = {
  'toolbar-height': '48px',
  'toolbar-bg': 'var(--dp-color-surface)',
  'toolbar-border-color': 'var(--dp-color-border)',
  'toolbar-padding-x': 'var(--dp-spacing-md)',
  'toolbar-gap': 'var(--dp-spacing-sm)',
  'toolbar-border-radius': 'var(--dp-border-radius-md)',
  'toolbar-separator-color': 'var(--dp-color-border)',
  'toolbar-separator-width': '1px',
} as const;
